import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';


@Injectable()
export class ToolsAndEquipmentManualsService {

  private serviceBulletinFilter: string;

  constructor(private http: HttpClient) { }

  // Equipment manual API

  getAllEquipmentManuals(): Observable<any> {
    return this.http.get('equipment-manual/all',{withCredentials : true});
  }

  getAllEquipmentManualsForAdmin(makeName): Observable<any> {
    return this.http.get(`equipment-manual/all/makeName/${makeName}`, {withCredentials : true});
  }

  getNewEquipmentManuals(): Observable<any> {
    return this.http.get('equipment-manual/new',{withCredentials : true});
  }

  getUserEquipmentManualHistory(userId): Observable<any> {
    return this.http.get(`user-info/qID/${userId}/equipmentManualHistorylist`,{withCredentials : true});
  }

  addEquipmentManualToHistory(userId, manualId): Observable<any> {
    return this.http.post(`user-info/qID/${userId}/addEquipmentManualToHistorylist/${manualId}`, '',{withCredentials : true});
  }

  // Tools Report API
  getAllToolsReport(): Observable<any> {
    return this.http.get('tool-report/all/toolReport',{withCredentials : true});
  }

  getNewToolsReport(): Observable<any> {
    return this.http.get('tool-report/new',{withCredentials : true});
  }

  getUserToolReportHistory(userId): Observable<any> {
    return this.http.get(`user-info/qID/${userId}/toolReportHistorylist`,{withCredentials : true});
  }

  addReportToUserHistory(userId, reportId): Observable<any> {
    return this.http.post(`user-info/qID/${userId}/addToolReportToHistorylist/${reportId}`, '',{withCredentials : true});
  }

  getReportInforById(reportId): Observable<any> {
    return this.http.get(`tool-report/findOneByToolReportId/${reportId}`,{withCredentials : true});
  }
  
  saveFilterData(filter: string) {
    this.serviceBulletinFilter = filter;
  }

  getFilterData(): string {
    return this.serviceBulletinFilter;
  }
}
